import React, { createContext, useContext, useMemo, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("pt");

  const toggle = useCallback(() => {
    setLang((l) => (l === "pt" ? "en" : "pt"));
  }, []);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      toggle,
      t: translations[lang],
    }),
    [lang, toggle]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
